import VueRouter from 'vue-router'

import TabbarView from './TabbarView.vue'
import EmptyView from './EmptyView.vue'

import Recommend from './components/Recommend/Recommend.vue'

import MatchList from './components/Match/MatchList.vue'
import MatchDetail from './components/Match/MatchDetail.vue'

import RouteList from './components/Route/RouteList.vue'
import RouteDetail from './components/Route/RouteDetail.vue'
import TourDetail from './components/WorldCup/TourDetail.vue'
import TourConfirm from './components/WorldCup/TourConfirm.vue'
import Search from './components/Search/Search.vue'
import User from './components/User/User.vue'
// TODO 导入定制旅行组件
import CustomList from './components/Custom/CustomList.vue'
import CustomEdit from './components/Custom/CustomEdit.vue'
import CustomExplain from './components/Custom/CustomExplain.vue'
import TalentRaiders from './components/Custom/TalentRaiders.vue'
import CustomArticle from './components/Custom/CustomArticle.vue'
import CustomIntro from './components/Custom/CustomIntro.vue'
import CustomIllustrate from './components/Custom/CustomIllustrate.vue'
// TODO 导入体育游组件
import SportsTourList from './components/SportsTour/SportsTourList.vue'
import SportsTourPackageConfirm from './components/SportsTour/SportsTourPackageConfirm.vue'
import SportsTourPackageConfirm2 from './components/SportsTour/SportsTourPackageConfirm2.vue'
import SportsTourPackageAddPeople from './components/SportsTour/SportsTourPackageAddPeople.vue'
import SportsTourCustomConfirm from './components/SportsTour/SportsTourCustomConfirm.vue'
import SportsTourPackageNotice from './components/SportsTour/SportsTourPackageNotice.vue'
import TravelOrderList from './components/SportsTour/Order/TravelOrderList.vue'
import CustomSuccess from './components/SportsTour/CustomSuccess.vue'
import store from './vuex/store'
import { isLoggedIn } from './utils/auth'

const routes = [{
  path: '/tab',
  component: TabbarView,
  children: [{
    path: 'worldCup',
    name: 'world-cup',
    component: () => import('./components/WorldCup/WorldCup.vue'),
  }, {
    path: 'recommend',
    name: 'recommend',
    component: Recommend,
  }, {
    path: 'matches',
    name: 'match-list',
    component: MatchList,
  }, {
    path: 'routes',
    name: 'route-list',
    component: RouteList,
  }, {
    path: 'custom',
    name: 'custom-list',
    component: CustomList,
  }, {
    path: 'sportsTour',
    name: 'sports-tour-list',
    component: SportsTourList,
  }, {
    path: 'my',
    name: 'profile',
    component: User,
    meta: {
      requireLogin: true,
    },
    alias: '/my',
  }],
}, {
  path: '/header',
  component: EmptyView,
  children: [{
    path: 'match/:matchId',
    name: 'match-detail',
    component: MatchDetail,
    // component: () => import('./components/Match/MatchDetail.vue'),
    alias: '/match/:matchId',
  }, {
    path: 'route/:routeId',
    name: 'route-detail',
    component: RouteDetail,
    alias: '/route/:routeId',
  }, {
    path: 'tour/:tourId',
    name: 'tour-detail',
    component: TourDetail,
    alias: '/tour/:tourId',
  }, {
    path: 'sportsTour/:routeId',
    name: 'sports-tour-route-detail',
    component: () => import('./components/SportsTour/SportsTourRouteDetail.vue'),
  }, {
    path: 'sportsTourPackageConfirm/:routeId',
    name: 'sports-tour-package-confirm',
    component: SportsTourPackageConfirm,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'sportsTourPackageConfirm2/:routeId',
    name: 'sports-tour-package-confirm2',
    component: SportsTourPackageConfirm2,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'SportsTourPackageAddPeople/:userId/:personCount/:certificateType',
    name: 'sports-tourPackage-addPeople',
    component: SportsTourPackageAddPeople,
    meta: {
      keepAlive: false,
    },
  }, {
    path: 'sportsTourCustomConfirm/:routeId',
    name: 'sports-tour-custom-confirm',
    component: SportsTourCustomConfirm,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'travelOrderList',
    name: 'travel-order-list',
    component: TravelOrderList,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'customSuccess',
    name: 'custom-success',
    component: CustomSuccess,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'travelOrderSuccess',
    name: 'travel-order-success',
    component: () => import('./components/SportsTour/Order/TravelOrderSuccess.vue'),
    meta: {
      requireLogin: true,
    },
    alias: '/travelOrderSuccess',
  }, {
    path: 'packageNotice',
    name: 'sports-tour-package-notice',
    component: SportsTourPackageNotice,
  }, {
    path: 'sportsTourCustomIntro/:customOrderId',
    name: 'sports-tour-custom-intro',
    component: () => import('./components/SportsTour/SportsTourCustomIntro.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'tourConfirm/:tourId',
    name: 'tour-confirm',
    component: TourConfirm,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'orderConfirm/:matchId',
    name: 'order-confirm',
    component: () => import('./components/Order/OrderConfirm.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'matchOrderConfirm/',
    name: 'match-order-confirm',
    component: () => import('./components/Order/MatchOrderConfirm.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'routeConfirm/:routeId',
    name: 'route-confirm',
    component: () => import('./components/Route/RouteConfirm.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'orderSuccess',
    name: 'order-success',
    component: () => import('./components/Order/OrderSuccess.vue'),
    meta: {
      requireLogin: true,
    },
    alias: '/orderSuccess',
  }, {
    path: 'orderPayRedirectResult',
    name: 'order-pay-redirect-result',
    component: () => import('./components/Order/OrderPayRedirectResult.vue'),
    meta: {
      requireLogin: true,
    },
    alias: '/orderPayRedirectResult',
  }, {
    path: 'order/:orderId',
    name: 'order-detail',
    component: () => import('./components/Order/OrderDetail.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'order',
    name: 'order-list',
    component: () => import('./components/Order/Order.vue'),
    alias: '/order',
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'payOrder',
    name: 'pay-order',
    component: () => import('./components/Order/OrderPay.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'login',
    name: 'login',
    component: () => import('./components/Auth/Login.vue'),
  }, {
    path: 'register',
    name: 'register',
    component: () => import('./components/Auth/Register.vue'),
  }, {
    path: 'bindMobile',
    name: 'bind-mobile',
    component: () => import('./components/Auth/BindMobile.vue'),
    meta: {
      requireLogin: false,
    },
    // alias: '/bindMobile',
  }, {
    path: 'resetPassword',
    name: 'reset-password',
    component: () => import('./components/Auth/ResetPassword.vue'),
    meta: {
      requireLogin: false,
    },
    // alias: '/resetPassword',
  }, {
    path: 'search',
    name: 'search-match',
    component: Search,
    meta: {
      requireLogin: false,
    },
  }, {
    path: 'question',
    name: 'question-list',
    component: () => import('./components/Question/QuestionList.vue'),
    meta: {
      requireLogin: false,
    },
  }, {
    path: 'myQuestion',
    name: 'my-question',
    component: () => import('./components/Question/QuestionList.vue'),
  }, {
    path: 'myFavour',
    name: 'my-favour',
    component: () => import('./components/User/Favour.vue'),
  }, {
    path: 'help',
    name: 'help',
    component: () => import('./components/User/Help.vue'),
  }, {
    path: 'attn',
    name: 'attn-list',
    component: () => import('./components/Attn/AttnList.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'attn/attnEdit',
    name: 'attn-edit',
    component: () => import('./components/Attn/AttnEdit.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'attn/nameEdit',
    name: 'name-edit',
    component: () => import('./components/Attn/RealNameEdit.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'attn/addressEdit',
    name: 'address-edit',
    component: () => import('./components/Attn/AddressEdit.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'about',
    name: 'about',
    component: () => import('./components/User/About.vue'),
  }, {
    path: 'illustrate',
    name: 'illustrate',
    component: () => import('./components/User/Illustrate.vue'),
  }, {
    path: 'customEdit/:customId',
    name: 'custom-edit',
    component: CustomEdit,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'customExplain',
    name: 'custom-explain',
    component: CustomExplain,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'customIntro/:customOrderId',
    name: 'custom-intro',
    component: CustomIntro,
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'customIllustrate/:customOrderId',
    name: 'custom-illustrate',
    component: CustomIllustrate,
  }, {
    // 观赛攻略
    path: 'matchRaiders/:articleId',
    name: 'match-raiders',
    component: CustomArticle,
  }, {
    // 参考线路
    path: 'referRoute/:articleId',
    name: 'refer-route',
    component: CustomArticle,
  }, {
    // 出游攻略
    path: 'cityIntro/:articleId',
    name: 'city-intro',
    component: CustomArticle,
  }, {
    // 出游攻略
    path: 'showArticle/:articleId',
    name: 'show-article',
    component: CustomArticle,
  }, {
    // 达人分享
    path: 'talentRaiders/:sportsRouteId',
    name: 'talent-raiders',
    component: TalentRaiders,
  }, {
    // C2C买家购票,票列表
    path: 'ctcMatchTicket/:matchId',
    name: 'ctc-match-ticket',
    component: () => import('./components/Ctc/OrderPlace/CtcMatchTicket.vue'),
    alias: '/matchTicket/:matchId',
  }, {
    // C2C买家购票,选座
    path: 'ctcMatchChooseSeat/:matchId',
    name: 'ctc-match-choose-seat',
    component: () => import('./components/Ctc/OrderPlace/CtcMatchChooseSeat.vue'),
    alias: '/matchChooseSeat/:matchId',
  }, {
    // C2C买家购票
    path: 'ctcOrderBuy/:ticketId',
    name: 'ctc-order-buy',
    component: () => import('./components/Ctc/OrderPlace/CtcOrderBuy.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C卖家转票
    path: 'ctcOrderSell/:matchId',
    name: 'ctc-order-sell',
    component: () => import('./components/Ctc/OrderPlace/CtcOrderSell.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C卖家转票支付订单
    path: 'ctcSellerOrderPay/:orderId',
    name: 'ctc-seller-order-pay',
    component: () => import('./components/Ctc/OrderPay/CtcSellerOrderPay.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C买家转票支付订单
    path: 'ctcBuyerOrderPay/:orderId',
    name: 'ctc-buyer-order-pay',
    component: () => import('./components/Ctc/OrderPay/CtcBuyerOrderPay.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C卖家我的转票
    path: 'ctcSellerOrderList',
    name: 'ctc-seller-order-list',
    component: () => import('./components/Ctc/OrderList/CtcSellerOrderList.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C卖家认证
    path: 'ctcSellerAuth',
    name: 'ctc-seller-auth',
    component: () => import('./components/Ctc/Auth/CtcSellerAuth.vue'),
    meta: {
      requireLogin: true,
      keepAlive: true,
      flag: true
    },
  }, {
    path: 'sellerAgree',
    name: 'sellerAgree',
    component: () => import('./components/User/SellerAgree.vue')
  }, {
    // C2C买家支付订单成功
    path: 'ctcBuyerOrderSuccess',
    name: 'ctc-buyer-order-success',
    component: () => import('./components/Ctc/OrderPay/CtcBuyerOrderSuccess.vue'),
    meta: {
      requireLogin: true,
    },
    alias: '/ctcBuyerOrderSuccess',
  }, {
    // C2C买家订单详情
    path: 'ctcBuyerOrderDetail/:orderId',
    name: 'ctc-order-detail-buyer',
    component: () => import('./components/Ctc/OrderDetail/CtcOrderDetailBuyer.vue'),
    meta: {
      requireLogin: true,
    },
  },{
    // C2C卖家支付订单成功
    path: 'ctcSellerOrderSuccess',
    name: 'ctc-seller-order-success',
    component: () => import('./components/Ctc/OrderPay/CtcSellerOrderSuccess.vue'),
    meta: {
      requireLogin: true,
    },
    alias: '/ctcSellerOrderSuccess',
  }, {
    // C2C卖家订单详情（在售）
    path: 'ctcSellingOrderDetail/:orderId',
    name: 'ctc-order-detail-selling',
    component: () => import('./components/Ctc/OrderDetail/CtcOrderDetailSelling.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // C2C卖家订单详情（已售）
    path: 'ctcSoldOrderDetail/:orderId',
    name: 'ctc-order-detail-sold',
    component: () => import('./components/Ctc/OrderDetail/CtcOrderDetailSold.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    path: 'ctcSellerMatchList',
    name: 'c2c-seller-match-list',
    component: () => import('./components/Match/C2cSellerMatchList'),
  }, {
    // 我的钱包
    path: 'wallet',
    name: 'wallet-main',
    component: () => import('./components/Wallet/WalletMain.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 我的银行卡
    path: 'mineBankCard/:isDefault',
    name: 'mine-bank-card',
    component: () => import('./components/Wallet/BankCard/MineBankCard.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 资金明细、保证金明细
    path: 'mineBills/:billType',
    name: 'mine-bills',
    component: () => import('./components/Wallet/MineBills.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 提现
    path: 'drawCash',
    name: 'draw-cash',
    component: () => import('./components/Wallet/BankCard/DrawCash.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 提现明细
    path: 'drawCashHistory',
    name: 'draw-cash-history',
    component: () => import('./components/Wallet/BankCard/DrawCashHistory.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 支付密码管理
    path: 'payPwdManager',
    name: 'pay-pwd-manager',
    component: () => import('./components/Wallet/Pay/PayPwdManager.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 支付密码设置、修改
    path: 'payPassword/:isUpdatePayPwd',
    name: 'pay-password',
    component: () => import('./components/Wallet/Pay/PayPassword.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 重置支付密码
    path: 'resetPayPassword',
    name: 'reset-pay-password',
    component: () => import('./components/Wallet/Pay/ResetPayPassword.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 设置密码使用范围
    path: 'payPasswordSetting',
    name: 'pay-password-setting',
    component: () => import('./components/Wallet/Pay/PayPasswordSetting.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 添加绑定银行卡
    path: 'addBankCard',
    name: 'add-bank-card',
    component: () => import('./components/Wallet/BankCard/AddBankCard.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 银行卡管理
    path: 'bankCardManager',
    name: 'bank-card-manager',
    component: () => import('./components/Wallet/BankCard/BankCardManager.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 我的资料
    path: 'userInfo',
    name: 'user-info',
    component: () => import('./components/User/UserInfo/UserInfo.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 修改手机
    path: 'modifyMobile',
    name: 'modify-mobile',
    component: () => import('./components/User/UserInfo/ModifyMobile.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 注销账号
    path: 'cancelAccount',
    name: 'cancel-account',
    component: () => import('./components/User/UserInfo/CancelAccount.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 修改密码
    path: 'updatePwd',
    name: 'update-pwd',
    component: () => import('./components/User/UserInfo/UpdatePwd.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 我的优惠卷
    path: 'coupon',
    name: 'coupon-list',
    component: () => import('./components/Coupon/CouponList.vue'),
    meta: {
      requireLogin: true,
    },
  }, {
    // 优惠券领取活动
    path: 'couponDraw/:activityId',
    name: 'coupon-draw',
    component: () => import('./components/Coupon/CouponDraw.vue'),
  }, {
    // 国庆节活动
    path: 'nationalDay/:activityId',
    name: 'national-day',
    component: () => import('./components/Activity/NationalDayActivity.vue'),
  }],
}, {
  path: '*',
  redirect: '/tab/matches',
}]

const router = new VueRouter({
  routes,
})

const commit = store.commit || store.dispatch

router.beforeEach((to, from, next) => {
  commit('UPDATE_LOADING', true)
  if (to.meta && to.meta.requireLogin && !isLoggedIn()) {
    next({
      name: 'login',
      query: {
        next: window.encodeURIComponent(to.fullPath),
        source: window.encodeURIComponent(from.path),
      },
    })
  } else {
    document.title = '观赛日-体育赛事门票预定、体育旅游服务平台'
    document.querySelector('meta[name="description"]').setAttribute('content', '观赛日APP是国内领先的体育主题旅游服务平台，提供全球热门体育赛事门票预定和体育旅游服务预定，为体育爱好者提供一站式的体育主题旅游服务。')
    next()
  }
})

router.afterEach(() => {
  commit('UPDATE_LOADING', false)
})
export default router



// WEBPACK FOOTER //
// ./client/routers.js